import { render, staticRenderFns } from "./ExhibitorResetPassword.vue?vue&type=template&id=42c6a56a"
import script from "./ExhibitorResetPassword.vue?vue&type=script&lang=ts"
export * from "./ExhibitorResetPassword.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports